var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 16,
    fill: "#FCEDE8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 16C27.0625 16 28 16.9375 28 18V20H36V18C36 16.9375 36.875 16 38 16C39.0625 16 40 16.9375 40 18V20H43C44.625 20 46 21.375 46 23V26H18V23C18 21.375 19.3125 20 21 20H24V18C24 16.9375 24.875 16 26 16ZM18 28H46V45C46 46.6875 44.625 48 43 48H21C19.3125 48 18 46.6875 18 45V28ZM38.5625 35.0625C39.125 34.5 39.125 33.5625 38.5625 33C37.9375 32.375 37 32.375 36.4375 33L30.5 38.9375L27.5625 36C26.9375 35.375 26 35.375 25.4375 36C24.8125 36.5625 24.8125 37.5 25.4375 38.0625L29.4375 42.0625C30 42.6875 30.9375 42.6875 31.5625 42.0625L38.5625 35.0625Z",
    fill: "#E66E2A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.8710e82583343bd13f3c236e563c7d34.svg";
export { ForwardRef as ReactComponent };